module.exports = __webpack_public_path__ + "img/Locke-2.8e31cb15.png";